export default __webpack_public_path__ + "static/dog-with-ball-7ff5d886f69998cbea0dec7e8c5aeec6.jpg";